import { render, staticRenderFns } from "./TransactionStatement.vue?vue&type=template&id=1471a84d&scoped=true&"
import script from "./TransactionStatement.vue?vue&type=script&lang=js&"
export * from "./TransactionStatement.vue?vue&type=script&lang=js&"
import style0 from "./TransactionStatement.vue?vue&type=style&index=0&id=1471a84d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1471a84d",
  null
  
)

export default component.exports